// General purpose table for displaying list of bills
// e.g. bills a given lawmaker has sponsored
// or key bills on index page
// or bills at given point in process

import React, { useState } from 'react';
import PropTypes from "prop-types"
import { Link } from 'gatsby'
import { css } from '@emotion/react'

import {
    numFormat,
    absChangeFormat,
    percentChangeFormat,
} from '../js/utils'

const inlineButtonCss = css`
  display: inline-block;
  border: none;
  padding: 0.2em 0.5em;
  border: 1px solid var(--tan6);
  /* color: #ce5a00; */
  color: var(--tan6);
  background-color: rgba(256, 256, 256, 0);
  text-align: left;
  font-size: 1em;
  text-transform: none;
  letter-spacing: normal;
  font-weight: normal;

  :hover {
    background-color: rgba(256, 256, 256, 0);
    border: 1px solid #ce5a00;
    color: #ce5a00;
    text-decoration: none;
  }
`

const tableStyle = css`
    width: 100%;
    margin-top: 0.5em;
    thead {
        border-bottom: 1px solid red;
        
    }
    tbody {
        border-top: 1px solid #ddd;
        /* background-color: #eae3da; */
    }
    tr {
        border-bottom: 1px solid #666;
        margin: 0 0.2em;

        :first-of-type {
            border-top: 1px solid #666;
        }
    }
    td {
        padding: 0.5em 0.5em;
    }
    th {
        font-weight: normal;
        font-style: italic;
        vertical-align: bottom;
        padding: 0.3em 0.5em;
        text-align: left;
    }
`

const bottomFadeCss = css`
    position: relative;
    :after {
        content: '';
        position: absolute;
        z-index: 10;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 4em;
        background-image : linear-gradient(to bottom, 
                    rgba(255,255,255, 0), 
                    rgba(255,255,255, 1) 70%);

    }
`

const noteStyle = css`
    font-style: italic;
    font-size: 0.9em;
    margin-bottom: 0.3em;
    margin-top: 0.3em;
`

const numCell = css`
    text-align: right;
`
const labelCell = css`
    font-weight: bold;
`


const DEFAULT_DISPLAY_LIMIT = 11
const DEFAULT_SORT = (a, b) => +b.pop_change - +a.pop_change
const suppressCount = false

function Table({ rows, geoName }) {
    const [isExpanded, setExpansion] = useState(false)
    const sortFunction = DEFAULT_SORT
    const displayLimit = DEFAULT_DISPLAY_LIMIT

    const sorted = rows.sort(sortFunction)
    const rendered = isExpanded ? sorted : sorted.slice(0, displayLimit)
    const rowElements = rendered.map((d, i) => <Row key={String(i)} d={d} />)

    return <div>
        <table css={isExpanded ? [tableStyle] : [tableStyle, bottomFadeCss]}>
            <thead>
                <tr>
                    <th>{geoName}</th>
                    <th>2020 Population</th>
                    <th>Change from 2010</th>
                    <th>% change from 2010</th>
                </tr>
            </thead>
            <tbody>{rowElements}</tbody>
        </table>
        <div css={noteStyle}>
            {!suppressCount && <span>Showing {rendered.length} of {rows.length}</span>}
            <span><span>. </span>
                <button css={inlineButtonCss} onClick={() => setExpansion(!isExpanded)}>
                    {isExpanded ? 'See fewer' : 'See all'}
                </button>
            </span>
        </div>

    </div>
}


const Row = ({ d }) => {
    return <tr>
        <td css={labelCell}>{d.NAME}</td>
        <td css={numCell}>{numFormat(d.pop_total)}</td>
        <td css={numCell}>{absChangeFormat(d.pop_change)}</td>
        <td css={numCell}>{percentChangeFormat(d.pop_pchange)}</td>
    </tr>
}


export default Table